import { render, staticRenderFns } from "./user-toolbar-menu.vue?vue&type=template&id=2a8d498d&scoped=true&lang=pug&"
import script from "./user-toolbar-menu.vue?vue&type=script&lang=ts&"
export * from "./user-toolbar-menu.vue?vue&type=script&lang=ts&"
import style0 from "./user-toolbar-menu.vue?vue&type=style&index=0&id=2a8d498d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8d498d",
  null
  
)

export default component.exports